var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { attrs: { id: "container-wrap-footer" } }, [
    _c("section", { attrs: { id: "content-footer" } }, [
      _c("div", { attrs: { id: "promo2" } }, [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { attrs: { id: "store-btn-bg" } }, [
            _c(
              "div",
              {
                staticClass: "white-btn btn",
                on: { click: _vm.handleDownloadClick },
              },
              [_c("p", [_vm._v("App download")])]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(1),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        staticClass: "img_todoenglish_logo",
        attrs: {
          src: require("@/assets/coupon/img/img-todoenglish-logo-wh-large.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "container" }, [
        _c("p", { staticClass: "rights" }, [
          _vm._v("ⓒ 2018 Enuma, Inc. All Rights Reserved."),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("p", [_vm._v("北京埃努码信息技术有限公司")]),
          _vm._v(" "),
          _c("p", { staticClass: "v-line" }),
          _vm._v(" "),
          _c("p", { staticStyle: { color: "#cccccc" } }, [_vm._v("法人  ")]),
          _vm._v(" "),
          _c("p", [_vm._v("李在轩")]),
          _vm._v(" "),
          _c("p", { staticClass: "v-line" }),
          _vm._v(" "),
          _c("p", [_vm._v("京ICP备16005665号-1")]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "北京市朝阳区工人体育场北里8号院1号楼10层01-1105第A1157号办公室"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }